import { createContext, useContext } from "react";

import { Schemas } from "../../../../types";

export const initialGroupValues: Schemas["CustomerGroupCreate"] = {
  name: "",
  applicant_facing_name: "",
  address: {
    country: "",
    administrative_division_1: "",
    locality: "",
    address_line_1: "",
    postal_code: "",
    unit_number: "",
  },
  permissible_purpose:
    "" as Schemas["CustomerGroupCreate"]["permissible_purpose"],
  billing_profile: "",
  users: [],
};

interface CreateGroupContextType {
  customerGroup: Schemas["CustomerGroupCreate"];
  setCustomerGroup: (customerGroup: Schemas["CustomerGroupCreate"]) => void;
  currentStep: number;
  totalSteps: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const CreateGroupContext = createContext<CreateGroupContextType>({
  customerGroup: initialGroupValues,
  setCustomerGroup: (newState: Schemas["CustomerGroupCreate"]) => newState,
  currentStep: 0,
  totalSteps: 0,
  goToNextStep: () => {},
  goToPrevStep: () => {},
});

export function useCreateGroupContext() {
  return useContext(CreateGroupContext);
}
